import { render, staticRenderFns } from "./linkList.vue?vue&type=template&id=63d36eac&scoped=true"
import script from "./linkList.vue?vue&type=script&lang=js"
export * from "./linkList.vue?vue&type=script&lang=js"
import style0 from "./linkList.vue?vue&type=style&index=0&id=63d36eac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d36eac",
  null
  
)

export default component.exports